import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  private socket: Socket;

  constructor() {

    this.socket = io('https://kodex.workinsight.net:3003/', {
      transports: ['websocket'],
      secure: true
    });

    this.socket.on('connect', () => {

      console.log('✅ Connected to WebSocket:', this.socket.id);
    });

    this.socket.on('disconnect', () => {
      console.log('❌ Disconnected from WebSocket');
    });
  }

  // Emit an increment event
  incrementCount(userids: string, notification_obj: any) {
    this.socket.emit('count-updated', { userids, notification_obj });
  }

  // Listen for count updates
  onRecievedNotification(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('count-updated', data => {
        observer.next(data);
      });
    });
  }
}
